<template>
  <div class="orderDetail">
    <search-top
      @changeOrderBy="changeOrderBy"
      @handleInput="handleInput"
      :orderBy="orderBy"
      :isFilter="checkFilter()"
    ></search-top>
    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
        :disabled="checkModeType ? true : false"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="order" v-for="(order, index) in tableData" :key="index">
            <div class="checkBox">
              <van-checkbox
                v-model="order.isSelected"
                @change="handleCheckBox"
              ></van-checkbox>
            </div>
            <div class="container">
              <van-collapse v-model="activeNames">
                <van-collapse-item :name="index">
                  <template #title>
                    <div class="header">
                      <div class="number">
                        {{ $t.checkWaybill.mainWbNumber }}:
                        {{ order.PWB_Number }}
                      </div>
                      <div class="number">
                        {{ $t.checkWaybill.sideWbNumber }}:
                        {{ order.WB_Number }}
                      </div>
                      <div class="number" v-if="menuState == 2">
                        {{ $t.checkWaybill.jobNumber }}: {{ order.JobNumber }}
                      </div>
                    </div>
                  </template>
                  <div class="content" @click="gotoDetail(order)">
                    <div class="content-row">
                      {{ $t.checkWaybill.shippingDate }}:
                      {{ order.CreateTime.split(" ")[0] }}
                    </div>
                    <div class="content-row">
                      {{ $t.checkWaybill.type }}: {{ order.WB_TypeStr }}
                    </div>
                    <div class="content-row">
                      {{ $t.checkWaybill.goodState }}: {{ order.StateName }}
                    </div>
                    <div class="content-row">
                      {{ $t.checkWaybill.warehouse }}: {{ order.WarehouseName }}
                    </div>
                    <div class="content-row">
                      {{ $t.checkWaybill.paymentStatus }}:
                      {{ order.PaymentStateStr }}
                    </div>
                    <div class="content-row">
                      PreAlert:
                      <span class="content-icon" v-if="order.IsPreAlert > 0"
                        ><van-icon name="success"
                      /></span>
                    </div>
                  </div>
                  <div class="footer"></div>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.businessType }}</div>
        <van-radio-group
          v-model="wbType"
          direction="horizontal"
          :disabled="checkModeType == 2 ? true : false"
        >
          <van-radio name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio name="5">{{ $t.meta.wbType5 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.checkWaybill.platformOrder }}</div>
        <van-radio-group v-model="platformOrderType" direction="horizontal">
          <van-radio name="1">VANCHEEN</van-radio>
          <van-radio name="2">TEMU</van-radio>
        </van-radio-group>

        <van-field
          v-model="deliveryCustomer.text"
          :label="$t.checkWaybill.deliveryCustomer"
          :placeholder="$t.meta.input"
          @click="onShowEmit('showCheckWaybillDeliveryCustomer')"
          clickable
          readonly
        />

        <van-field
          v-model="receiveCustomer.text"
          :label="$t.checkWaybill.receiveCustomer"
          :placeholder="$t.meta.input"
          @click="onShowEmit('showCheckWaybillReceiveCustomer')"
          clickable
          readonly
        />

        <van-field
          clickable
          readonly
          :value="selectedCountry.text"
          :label="$t.checkWaybill.receiveCountry"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showCheckWaybillCountry')"
        />

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <option-list
      event="showCheckWaybillCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showCheckWaybillWarehouse"
      :options="warehouseList"
      @onSelect="onSelectWarehouse"
    ></option-list>

    <option-list
      event="showCheckWaybillDriver"
      :options="employeeList"
      @onSelect="onSelectDriver"
    ></option-list>

    <option-list
      event="showCheckWaybillVehicle"
      :options="vehiclesList"
      @onSelect="onSelectVehicle"
    ></option-list>

    <fetch-list
      event="showCheckWaybillDeliveryCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectDeliveryCustomer"
    ></fetch-list>

    <fetch-list
      event="showCheckWaybillReceiveCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectReceiveCustomer"
    ></fetch-list>

    <van-popup v-model="showStatePicker" round position="bottom">
      <van-picker
        :title="$t.checkWaybill.bulkUpdate"
        show-toolbar
        :columns="stateList"
        @confirm="stateConfirm"
        :confirm-button-text="$t.meta.confirm"
        @cancel="stateCancel"
        :cancel-button-text="$t.meta.cancel"
      />
    </van-popup>

    <van-dialog
      :title="wbDialogTitle"
      width="90%"
      v-model="showWbDialog"
      @confirm="wbNumberConfirm"
      @cancel="wbNumberCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="wbDialogType == 'view' ? false : true"
    >
      <slot name="default">
        <div class="checkWaybill-alert">
          <van-form label-width="120px">
            <van-field
              v-model="form.PWB_Number"
              :label="$t.checkWaybill.mainWbNumber"
              :placeholder="$t.meta.input"
              :disabled="wbDialogType == 'view' ? true : false"
            />

            <div class="multi-table" v-if="form.FileList">
              <van-field name="stepper" :label="$t.checkWaybill.fileList">
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="form.FileList.length"
                    @minus="handleFileListDel"
                    @plus="handleFileListAdd"
                    :disable-input="true"
                    :disabled="wbDialogType == 'view' ? true : false"
                  />
                </template>
              </van-field>
              <div v-for="(item, index) in form.FileList" :key="index">
                <div class="multi-table-header" v-if="wbDialogType != 'view'">
                  <div class="multi-table-title"></div>
                  <div class="multi-table-btn" @click="handleFileListDelByIndex(index)">
                    <van-icon name="close" />
                  </div>
                </div>
                <van-field :label="'No.' + (index + 1)">
                  <template #input>
                    <van-button
                      @click="imagePreview(imgUrlFilter(item.FileAddress))"
                      type="primary"
                      size="small"
                      style="vertical-align: top; margin: 10px 30px 10px 0px"
                      v-if="item.FileAddress"
                      >{{ $t.meta.view }}</van-button
                    >
                    <van-uploader
                      :after-read="afterRead1"
                      @click-upload="uploaderClick(index)"
                    >
                      <van-image
                        :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                        width="50"
                        height="50"
                        fit="contain"
                        style="vertical-align: top"
                        v-if="item.FileAddress"
                      ></van-image>
                      <van-button
                        type="info"
                        size="small"
                        style="vertical-align: top; margin: 10px 30px 10px 0px"
                        v-else
                        >{{ $t.meta.upload }}</van-button
                      >
                    </van-uploader>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.checkWaybill.expressWarehouse"
      width="90%"
      v-model="showCargoDialog"
      @confirm="cargoConfirm"
      @cancel="cargoCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="checkWaybill-alert">
          <van-form label-width="80px" class="checkWaybill-alert-form">
            <van-field
              clickable
              readonly
              required
              :value="cargoForm.WHIdStr"
              :label="$t.checkWaybill.warehouse"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showCheckWaybillWarehouse')"
            />

            <van-field
              clickable
              readonly
              required
              :value="cargoForm.DriverIdStr"
              :label="$t.checkWaybill.driver"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showCheckWaybillDriver')"
            />

            <van-field
              clickable
              readonly
              required
              :value="cargoForm.VehicleIdStr"
              :label="$t.checkWaybill.vehicle"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showCheckWaybillVehicle')"
            />

            <van-field
              required
              v-model="cargoForm.MawbNumber"
              :label="$t.checkWaybill.mawbNumber"
              :placeholder="$t.meta.input"
            />
          </van-form>

          <div class="list-container" v-for="(item, index) in waybillIdList" :key="index">
            <div class="list-item">
              {{ $t.checkWaybill.mainWbNumber }}：{{ item.PWB_Number }}
            </div>
            <div class="list-item">
              {{ $t.checkWaybill.sideWbNumber }}：{{ item.WB_Number }}
            </div>
            <div class="list-item">
              {{ $t.checkWaybill.goodsName }}：{{ item.GoodsDescribe }}
            </div>
            <div class="list-item">
              {{ $t.checkWaybill.pNumber }}：{{ item.AllBoxNumber }}
            </div>
            <div class="list-item">
              {{ $t.checkWaybill.weight }}：{{ item.AllWeight }}
            </div>
          </div>
        </div>
      </slot>
    </van-dialog>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />
    <van-action-sheet
      v-model="moreSheetShow"
      :actions="moreSheetActions"
      @select="moreSheetSelect"
    />

    <div class="tool-bar">
      <van-notice-bar
        left-icon="warning-o"
        :text="$t.checkWaybill.preAlertNotice"
        v-if="isToggle && checkModeType == 1"
      />
      <van-notice-bar
        color="#1989fa"
        background="#ecf9ff"
        left-icon="warning-o"
        :text="$t.checkWaybill.cargoNotice"
        v-if="isToggle && checkModeType == 2"
      />
      <div v-if="isToggle">
        <van-button
          type="info"
          class="confirm-button"
          @click="confirmCheckMode"
          :disabled="waybillIdList.length > 0 || wbNumberList.length > 0 ? false : true"
          >{{ $t.meta.confirm }}</van-button
        >
        <van-button class="cancel-button" @click="cancelCheckMode">{{
          $t.meta.cancel
        }}</van-button>
      </div>
      <div v-else>
        <van-button
          type="info"
          class="sheet-button"
          block
          @click="handleSheetShow"
          :disabled="wbNumberList.length > 0 ? false : true"
          >{{ $t.meta.menu }}</van-button
        >
        <van-button class="more-button" @click="handleMoreSheetShow">{{
          $t.meta.more
        }}</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import SearchTop from "./components/SearchTop";
import OptionList from "@components/optionList/OptionList.vue";
import FetchList from "@components/fetchList/FetchList.vue";

import {
  List,
  Image,
  Icon,
  Button,
  Popup,
  Form,
  Field,
  Tab,
  Tabs,
  Radio,
  RadioGroup,
  Collapse,
  CollapseItem,
  DatetimePicker,
  ActionSheet,
  Checkbox,
  Picker,
  Stepper,
  Uploader,
  NoticeBar,
} from "vant";

import Vue from "vue";
Vue.use(Image)
  .use(Icon)
  .use(Button)
  .use(Popup)
  .use(Form)
  .use(Field)
  .use(Tab)
  .use(Tabs)
  .use(Radio)
  .use(RadioGroup)
  .use(Collapse)
  .use(CollapseItem)
  .use(DatetimePicker)
  .use(ActionSheet)
  .use(Checkbox)
  .use(Picker)
  .use(Stepper)
  .use(Uploader)
  .use(NoticeBar);

export default {
  name: "checkWaybill",
  components: {
    SearchTop,
    "van-list": List,
    OptionList,
    FetchList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.checkWaybill.export1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.checkWaybill.export2,
          name: 2,
          count: 0,
        },
      ],
      activeNames: [],
      stateList: [], //更新状态
      countryList: [], //目的港国家
      wbNumberList: [], // pre-alert勾选
      waybillIdList: [], // 快递货物勾选
      warehouseList: [], //仓库列表
      employeeList: [], //快递员工列表
      vehiclesList: [], //车辆列表
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      orderBy: "",
      searchText: "",
      showFilter: false,
      wbType: "",
      platformOrderType: null,
      isPreAlert: 0,
      isFilterCargoWarehousing: 0,
      deliveryCustomer: { text: "", value: null },
      receiveCustomer: { text: "", value: null },
      selectedCountry: { text: "", value: null },
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      moreSheetShow: false,
      moreSheetActions: [],
      showStatePicker: false,
      isToggle: false,
      checkModeType: null,
      //添加/修改主运单号
      showWbDialog: false,
      wbDialogType: "add",
      wbDialogTitle: this.$t.checkWaybill.addWbNumber,
      form: {
        PWB_Number: "",
        FileList: [],
      },
      filesIndex: 0,
      //快递货物入库
      showCargoDialog: false,
      cargoForm: {
        //仓库
        WHId: "",
        WHIdStr: "",
        //司机
        DriverId: "",
        DriverIdStr: "",
        // 车辆
        VehicleId: "",
        VehicleIdStr: "",
        //大箱件数
        MawbNumber: "",
        WaybillIdList: [],
      },
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.wbNumberList = [];
      this.waybillIdList = [];
      this.getList(1);
    },
  },
  created() {
    this.getLogisticsStateList();
    this.getCountryList();
  },
  methods: {
    initCargoData() {
      this.cargoForm.WHId = "";
      this.cargoForm.WHIdStr = "";
      this.cargoForm.DriverId = "";
      this.cargoForm.DriverIdStr = "";
      this.cargoForm.VehicleId = "";
      this.cargoForm.VehicleIdStr = "";
      this.cargoForm.WaybillIdList = [];
    },
    cargoConfirm() {
      this.$commonMethod.showLoading();
      var param = this.cargoForm;
      var waybillIdList = [];
      for (var waybill of this.waybillIdList) {
        waybillIdList.push(waybill.WB_Id);
      }
      param.WaybillIdList = waybillIdList;
      this.$api.logisticsManagement
        .addExpressCargoWarehousing(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.waybillIdList = [];
          this.initCargoData();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
      this.showCargoDialog = false;
    },
    cargoCancel() {
      this.showCargoDialog = false;
    },
    toPreAlert() {
      var WB_NumberList = [];
      for (var item of this.wbNumberList) {
        if (item.WB_Number) {
          WB_NumberList.push(item.WB_Number);
        }
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "preAlert",
        name: "preAlert",
        query: [
          {
            name: "WB_NumberList",
            value: WB_NumberList,
          },
          {
            name: "Type",
            value: "new",
          },
        ],
      });
    },
    confirmCheckMode() {
      if (this.checkModeType == 1) {
        this.toPreAlert();
      }
      if (this.checkModeType == 2) {
        this.getOptions().then((success) => {
          if (success) {
            this.showCargoDialog = true;
          }
        });
      }
    },
    cancelCheckMode() {
      this.wbNumberList = [];
      this.waybillIdList = [];
      this.isToggle = false;
      this.checkModeType = null;
      this.isPreAlert = 0;
      this.wbType = "";
      this.isFilterCargoWarehousing = 0;
      this.initList();
      this.getList(1);
    },
    toggleCheckMode(type) {
      this.wbNumberList = [];
      this.waybillIdList = [];
      this.isToggle = true;
      this.checkModeType = type;
      if (type == 1) {
        this.isPreAlert = 1;
      }
      if (type == 2) {
        this.wbType = "5";
        this.isPreAlert = this.menuState == 1 ? 1 : 0;
        this.isFilterCargoWarehousing = 1;
      }
      this.initList();
      this.getList(1);
    },
    wbNumberCancel() {
      this.showWbDialog = false;
    },
    wbNumberConfirm() {
      this.showWbDialog = false;
      if (this.wbDialogType == "edit") {
        this.editWayBillByPrimary();
      } else {
        this.addWayBillByPrimary();
      }
    },
    stateCancel() {
      this.showStatePicker = false;
    },
    stateConfirm(e) {
      this.showStatePicker = false;
      this.editWayBillLogisticsStatus(e.value);
    },
    sheetSelect(e) {
      if (e.className == "1") {
        this.showStatePicker = true;
      }
      if (e.className == "2") {
        var isHaveNumber = false;
        for (var item of this.wbNumberList) {
          if (item.PWB_Number) {
            isHaveNumber = true;
            break;
          }
        }
        if (isHaveNumber) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.checkWaybill.repeatBill,
            type: "error",
          });
        } else {
          this.wbDialogType = "add";
          this.wbDialogTitle = this.$t.checkWaybill.addWbNumber;
          this.showWbDialog = true;
        }
      }
      if (e.className == "3") {
        if (this.wbNumberList.length > 1) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.checkWaybill.selectSingle,
            type: "error",
          });
          return;
        }
        if (!this.wbNumberList[0].PWB_Number) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.checkWaybill.noWbNumber,
            type: "error",
          });
          return;
        }
        this.form.PWB_Number = this.wbNumberList[0].PWB_Number;
        this.form.FileList = [];
        this.wbDialogType = "edit";
        this.wbDialogTitle = this.$t.checkWaybill.editWbNumber;
        this.showWbDialog = true;
      }
      if (e.className == "4") {
        if (this.wbNumberList.length > 1) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.checkWaybill.selectSingle,
            type: "error",
          });
          return;
        }
        if (!this.wbNumberList[0].PWB_Number) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.checkWaybill.noWbNumber,
            type: "error",
          });
          return;
        }
        this.form.PWB_Number = this.wbNumberList[0].PWB_Number;
        this.getWayBillByPrimaryFileList().then((success) => {
          if (success) {
            this.wbDialogType = "view";
            this.wbDialogTitle = this.$t.checkWaybill.viewWbNumber;
            this.showWbDialog = true;
          }
        });
      }
      if (e.className == "5") {
        this.deleteWayBillInfo();
      }
      this.sheetShow = false;
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.isSelected);
      if (this.checkModeType == 2) {
        for (var item of items) {
          list.push({
            WB_Id: item.WB_Id,
            PWB_Number: item.PWB_Number,
            WB_Number: item.WB_Number,
            GoodsDescribe: item.GoodsDescribe,
            AllBoxNumber: item.AllBoxNumber,
            AllWeight: item.AllWeight,
          });
        }
        this.waybillIdList = list;
      } else {
        for (var item of items) {
          list.push({
            PWB_Number: item.PWB_Number,
            WB_Number: item.WB_Number,
          });
        }
        this.wbNumberList = list;
      }
    },
    moreSheetSelect(e) {
      if (e.className == "1") {
        this.toggleCheckMode(1);
      }
      if (e.className == "2") {
        this.toggleCheckMode(2);
      }
      this.moreSheetShow = false;
    },
    handleSheetShow() {
      var actions = [];
      if (this.menuState == 1) {
        actions = [
          { name: this.$t.checkWaybill.bulkUpdate, className: "1" },
          { name: this.$t.checkWaybill.addWbNumber, className: "2" },
          { name: this.$t.checkWaybill.editWbNumber, className: "3" },
          { name: this.$t.checkWaybill.viewWbNumber, className: "4" },
          { name: this.$t.checkWaybill.deleteWbNumber, className: "5" },
        ];
      }
      if (this.menuState == 2) {
        actions = [{ name: this.$t.checkWaybill.bulkUpdate, className: "1" }];
      }
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    handleMoreSheetShow() {
      var actions = [];
      if (this.menuState == 1) {
        actions = [
          {
            name: "Pre-Alert",
            className: "1",
          },
          {
            name: this.$t.checkWaybill.expressWarehouse,
            className: "2",
          },
        ];
      }
      if (this.menuState == 2) {
        actions = [
          {
            name: this.$t.checkWaybill.expressWarehouse,
            className: "2",
          },
        ];
      }

      this.moreSheetActions = actions;
      this.moreSheetShow = true;
    },
    gotoDetail(item) {
      var data = item;
      data.MenuState = this.menuState;
      localStorage.setItem("checkWaybillDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "checkWaybillDetail",
        name: "checkWaybillDetail",
        query: [],
      });
    },
    checkFilter() {
      if (
        this.deliveryCustomer.value ||
        this.receiveCustomer.value ||
        this.selectedCountry.value ||
        this.wbType ||
        this.platformOrderType ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.$bus.$emit("clearCheckWaybillSearch", true);
      this.searchText = "";
      this.wbType = "";
      this.platformOrderType = null;
      this.beginTime = "";
      this.endTime = "";
      this.showFilter = false;
      this.deliveryCustomer = { text: "", value: null };
      this.receiveCustomer = { text: "", value: null };
      this.selectedCountry = { text: "", value: null };
      this.changeOrderBy({ orderBy: this.orderBy });
    },
    filterSubmit() {
      this.showFilter = false;
      this.changeOrderBy({ orderBy: this.orderBy });
    },
    initList() {
      this.tableData = [];
      this.pageIndex = 1;
      this.loading = true;
      this.finished = false;
    },
    handleInput(text) {
      this.searchText = text;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCountry(item) {
      this.selectedCountry.text = item.text;
      this.selectedCountry.value = item.value;
    },
    onSelectWarehouse(item) {
      this.cargoForm.WHIdStr = item.text;
      this.cargoForm.WHId = item.value;
    },
    onSelectDriver(item) {
      this.cargoForm.DriverIdStr = item.text;
      this.cargoForm.DriverId = item.value;
    },
    onSelectVehicle(item) {
      this.cargoForm.VehicleIdStr = item.text;
      this.cargoForm.VehicleId = item.value;
    },
    onSelectDeliveryCustomer(item) {
      this.deliveryCustomer.text = item.text;
      this.deliveryCustomer.value = item.value;
    },
    onSelectReceiveCustomer(item) {
      this.receiveCustomer.text = item.text;
      this.receiveCustomer.value = item.value;
    },
    changeOrderBy(data) {
      if (data.orderBy == 2) {
        this.showFilter = true;
        return;
      }
      window.scrollTo({
        top: 0,
      });
      if (data.orderBy) {
        this.orderBy = data.orderBy;
      }
      if (data.text) {
        this.searchText = data.text;
      }
      this.initList();
      this.getList(1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getWarehouseManagementList(),
          this.getExpressEmployeeList(),
          this.getVehiclesList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getWarehouseManagementList() {
      return new Promise((resolve) => {
        var param = {
          WarehouseState: 1,
          PageIndex: 1,
          PageSize: 999,
        };
        this.$api.storage
          .getWarehouseManagementList(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.WarehouseName,
                value: item.WHId,
              };
              result.push(data);
            });
            this.warehouseList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getExpressEmployeeList() {
      return new Promise((resolve) => {
        this.$api.storage
          .getExpressEmployeeListByPage()
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.FullName + " , " + item.PhoneNumber,
                value: item.EMId,
              };
              result.push(data);
            });
            this.employeeList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getVehiclesList() {
      return new Promise((resolve) => {
        var param = {
          VehicleStatus: 1,
        };
        this.$api.storage
          .getVehiclesListByPage(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.LicensePlate + " , " + item.Brand,
                value: item.VehicleId,
              };
              result.push(data);
            });
            this.vehiclesList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getLogisticsStateList() {
      var param = {
        PageIndex: 1,
        PageSize: 100,
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      };
      this.$api.logisticsManagement
        .getLogisticsStateList(param)
        .then((res) => {
          var result = [];
          res.data.Data.forEach((item) => {
            let data = {
              text: item.StateName + " ( " + item.Id + " )",
              value: item.Id,
            };
            result.push(data);
          });
          this.stateList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCountryList() {
      this.$api.customerManagement
        .getCountryList()
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CountryName + "," + item.CountryName_en,
              value: item.CountryId,
            };
            result.push(data);
          });
          this.countryList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getWayBillByPrimaryFileList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          PWB_Number: this.form.PWB_Number,
        };
        this.$api.logisticsManagement
          .getWayBillByPrimaryFileList(param)
          .then((res) => {
            this.form.FileList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    addWayBillByPrimary() {
      this.$commonMethod.showLoading();
      var WB_NumberList = [];
      for (var number of this.wbNumberList) {
        if (number.WB_Number) WB_NumberList.push(number.WB_Number);
      }
      var param = {
        PWB_Number: this.form.PWB_Number,
        FileList: this.form.FileList,
        WB_NumberList: WB_NumberList,
        CompanyId: this.CompanyId,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .addWayBillByPrimary(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.wbNumberList = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editWayBillByPrimary() {
      this.$commonMethod.showLoading();
      var WB_NumberList = [];
      for (var item of this.wbNumberList) {
        if (item.WB_Number) {
          WB_NumberList.push(item.WB_Number);
        }
      }
      var param = {
        UserId: this.UserId,
        PWB_Number: this.form.PWB_Number,
        WB_NumberList: WB_NumberList,
        FileList: this.form.FileList,
      };
      this.$api.logisticsManagement
        .editWayBillByPrimary(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.wbNumberList = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editWayBillLogisticsStatus(id) {
      this.$commonMethod.showLoading();
      var WB_NumberList = [];
      for (var number of this.wbNumberList) {
        if (number.WB_Number) WB_NumberList.push(number.WB_Number);
      }
      var param = {
        WB_NumberList: WB_NumberList,
        StateId: id,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .editWayBillLogisticsStatus(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.tableData = [];
          this.wbNumberList = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteWayBillInfo() {
      this.$commonMethod.showLoading();
      var WB_NumberList = [];
      for (var number of this.wbNumberList) {
        if (number.WB_Number) WB_NumberList.push(number.WB_Number);
      }
      var param = {
        WB_NumberList: WB_NumberList,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .deleteWayBillInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data ? res.data : res.message,
            type: "success",
          });
          this.tableData = [];
          this.wbNumberList = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    getList(page) {
      return new Promise((resolve, reject) => {
        var param = {
          PlateType: this.menuState,
          WB_Number: this.searchText,
          BeginTime: this.beginTime,
          EndTime: this.endTime,
          PageIndex: page,
          PageSize: this.pageSize,
          CompanyId: this.CompanyId,
          UserId: this.UserId,
          WB_Type: this.wbType,
          PlatformOrderType: this.platformOrderType,
          IsPreAlert: this.isPreAlert,
          IsFilterCargoWarehousing: this.isFilterCargoWarehousing,
          DeliveryCustomerId: this.deliveryCustomer.value,
          ReceiveCustomerId: this.receiveCustomer.value,
          ReceiveCountryId: this.selectedCountry.value,
        };
        this.$api.logisticsManagement
          .getWayBillList(param)
          .then((res) => {
            this.tableData = this.tableData.concat(res.data.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
            this.activeNames = [];
            for (var idx in this.tableData) {
              this.activeNames.push(parseInt(idx));
            }
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
            reject();
          });
      });
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    handleFileListDelByIndex(index) {
      if (this.form.FileList.length > 0) {
        this.form.FileList.splice(index, 1);
      }
    },
    handleFileListDel() {
      if (this.form.FileList.length > 0) {
        this.form.FileList.pop();
      }
    },
    handleFileListAdd() {
      this.form.FileList.push({
        FileAddress: "",
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.orderDetail {
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .van-pull-refresh {
    overflow: unset;
  }
  .list {
    .order {
      font-size: 14px;
      .van-collapse:after {
        border: none;
      }
      .van-collapse {
        ::v-deep .van-collapse-item__content {
          padding: 0px;
          color: #323233;
          background: transparent;
        }
        .van-collapse-item {
          ::v-deep .van-icon {
            color: #000;
            margin-left: 50%;
          }
          ::v-deep .van-cell {
            padding: 0px;
            display: inline-block;
          }
          ::v-deep .van-cell:after {
            border: none;
          }
          ::v-deep .van-cell:before {
            border: none;
          }
        }
      }
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 65%;
        .expressNo {
          margin-bottom: 10px;
        }
        .inquiryNo {
          margin-bottom: 10px;
          .entry {
            color: $-color-primary;
          }
        }
        .itemName {
          margin-bottom: 10px;
        }
        .countryName {
          margin-bottom: 10px;
        }
        .category {
          margin-bottom: 10px;
          .entry {
            color: $-color-primary;
          }
        }
      }
      .right {
        vertical-align: top;
        display: inline-block;
        width: 35%;
        .images {
          width: 100px;
          height: 100px;
          overflow: hidden;
          vertical-align: middle;
        }
      }
      .packages {
        color: #666;
        font-size: 12px;
        .packages-item {
          display: inline-block;
          width: 50%;
          margin-bottom: 10px;
        }
      }
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 20px;
      }
      .container {
        box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
        padding: 20px 20px 10px 20px;
        .header {
          vertical-align: middle;
          display: inline-block;
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
          .number {
            margin-bottom: 10px;
            vertical-align: middle;
            display: inline-block;
            width: 70%;
          }
        }
        .content {
          vertical-align: middle;
          display: inline-block;
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
          margin-bottom: 10px;
          .content-row {
            margin-bottom: 5px;
            font-size: 12px;
            color: #999;
          }
          .content-icon {
            font-size: 20px;
            display: inline-block;
            width: 50px;
            text-align: center;
            .van-icon {
              color: #13ce66;
              margin: auto;
            }
          }
        }
        .footer {
          text-align: right;
          padding-bottom: 10px;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .sheet-button {
      width: 70%;
      border: none;
      border-radius: 0px;
      display: inline-block;
    }
    .more-button {
      background: #5029c3;
      color: #fff;
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 30%;
    }
    .cancel-button {
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 50%;
    }
    .confirm-button {
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 50%;
    }
  }
  .checkWaybill-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    .checkWaybill-alert-form {
      padding-bottom: 0 !important;
    }
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 20px;
      border-bottom: 1px solid #ebedf0;
      .list-item {
        margin-bottom: 10px;
        width: 100%;
        display: inline-block;
        vertical-align: top;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
    .multi-table {
      .multi-table-header {
        background: #ffffff;
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          width: 70%;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 30%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
